import { render } from "./ActionButton.vue?vue&type=template&id=40b8824d"
import script from "./ActionButton.vue?vue&type=script&lang=js"
export * from "./ActionButton.vue?vue&type=script&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=40b8824d&lang=css"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__